(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.vb-search-page-header');
  if (!root) return;
  const headerSectionEl = root.closest('[id^="shopify-section-"]');
  const headerSectionId = headerSectionEl ? headerSectionEl.id.replace('shopify-section-', '') : null;


  const input = root.querySelector('input[type="search"][name="q"]');
  const clearBtn = root.querySelector('[data-vb-search-reset]');
  const countEl = document.querySelector('[data-vb-results-count]');

  if (!input) return;

  // Find the "main" search results section instance on the page.
  // This lets us use Shopify's ?sections=... rendering without guessing filenames.
  const mainSectionEl =
    document.querySelector('[id^="shopify-section-template--"][id$="__main"]') ||
    document.querySelector('[id^="shopify-section-template--"][id*="__main"]');

  if (!mainSectionEl) return;

  const sectionInstanceId = mainSectionEl.id.replace('shopify-section-', '');

  // Helper: show/hide Clear button
  const toggleClear = () => {
    if (!clearBtn) return;
    clearBtn.hidden = !input.value;
  };
  toggleClear();

  // Debounce + abort in-flight requests
  let t = 0;
  let ctrl = null;

  function updateURL(q) {
    try {
      const url = new URL(window.location.href);
      if (q) url.searchParams.set('q', q);
      else url.searchParams.delete('q');
      url.searchParams.set('options[prefix]', 'last');
      history.replaceState({}, '', url.pathname + '?' + url.searchParams.toString());
    } catch (e) {}
  }

  function setCountFromHTML(doc) {
    if (!countEl) return;

    const newCount = doc.querySelector('[data-vb-results-count]');
    if (newCount) {
      countEl.innerHTML = newCount.innerHTML;
      countEl.hidden = newCount.hidden || !newCount.textContent.trim();
    } else {
      // fallback: hide if not found
      countEl.hidden = true;
    }
  }

  // Try to update only the product grid container (keeps filters JS more stable).
  // If we can't find it, fallback to replacing the whole main section.
  function swapResultsFromHTML(doc) {
    const selectors = [
      '#ProductGridContainer',
      '.product-grid-container',
      '[data-section-type="search-results"]',
      'main .collection',
      'main'
    ];

    for (const sel of selectors) {
      const current = document.querySelector(sel);
      const incoming = doc.querySelector(sel);
      if (current && incoming) {
        current.innerHTML = incoming.innerHTML;
        return;
      }
    }

    // Fallback: replace the whole main section contents
    const incomingSection = doc.getElementById(mainSectionEl.id);
    if (incomingSection) {
      mainSectionEl.innerHTML = incomingSection.innerHTML;
    }
  }

  async function fetchAndSwap(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();

    const sections = [sectionInstanceId, headerSectionId].filter(Boolean).join(',');
    const url =
      `/search?q=${encodeURIComponent(q)}&options[prefix]=last&sections=${encodeURIComponent(sections)}`;


    const res = await fetch(url, { signal: ctrl.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) return;

    const json = await res.json();
    // Update product grid from MAIN section
    const mainHTML = json[sectionInstanceId];
    if (mainHTML) {
      const mainDoc = new DOMParser().parseFromString(mainHTML, 'text/html');
      swapResultsFromHTML(mainDoc);
    }

    // Update results count from HEADER section
    if (headerSectionId && json[headerSectionId]) {
      const headerDoc = new DOMParser().parseFromString(json[headerSectionId], 'text/html');
      setCountFromHTML(headerDoc);
    }

  }

  function schedule(q) {
    clearTimeout(t);
    t = setTimeout(() => fetchAndSwap(q), 200);
  }

  input.addEventListener('input', () => {
    toggleClear();
    const q = input.value.trim();

    // Update the address bar so refresh/back behaves sensibly
    updateURL(q);

    // If empty: just hide count; you said you don't mind if products remain or disappear.
    if (!q) {
      if (countEl) countEl.hidden = true;
      return;
    }

    schedule(q);
  });

  // Keep your Clear button behaviour: clear text + update URL + (optionally) leave results as-is
  if (clearBtn) {
    clearBtn.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        input.value = '';
        toggleClear();
        if (countEl) countEl.hidden = true;

        updateURL('');

        try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
      },
      true
    );
  }
});

  } catch(e) { console.error(e); }
})();
})();
